/**
 * @generated SignedSource<<1c43125801a4525403933216f8674ad9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PrePaymentRequirement = "COLLECT_CARD_ON_FILE" | "FULL" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type EventSignUpPrimaryChargePaymentAssignment_event$data = {
  readonly memberSignUpProxyAllowed: boolean | null | undefined;
  readonly prePaymentRequirement: PrePaymentRequirement | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useGetPrimaryChargeNameAndPrice_event">;
  readonly " $fragmentType": "EventSignUpPrimaryChargePaymentAssignment_event";
};
export type EventSignUpPrimaryChargePaymentAssignment_event$key = {
  readonly " $data"?: EventSignUpPrimaryChargePaymentAssignment_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSignUpPrimaryChargePaymentAssignment_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSignUpPrimaryChargePaymentAssignment_event",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetPrimaryChargeNameAndPrice_event"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "memberSignUpProxyAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prePaymentRequirement",
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};

(node as any).hash = "0a5042faec06928725aa0c580f8553ef";

export default node;
